import { useState,  useRef,  useEffect } from 'react';
import { globalHistory } from '@reach/router'

const INITIAL_STATE = {
  offsetTop: 100,
  prevScrollPosition: 0,
  isSticky: false,
};

export default () => {
  const [navVisible, setNavVisible] = useState(false)
  const navRef = useRef()
  const [{ offsetTop, prevScrollPosition, isSticky }, setStickyNav] = useState(INITIAL_STATE)

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset
    const shouldNavBeSticky = prevScrollPosition > currentScrollPos
      && currentScrollPos > offsetTop

    setStickyNav((state) => ({
      ...state,
      isSticky: shouldNavBeSticky,
      prevScrollPosition: currentScrollPos,
    }))
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  })

  useEffect(() => {
    return globalHistory.listen(({ action }) => {
      if (action === 'PUSH') {
        setNavVisible(false)
      }
    })
  }, [setNavVisible])

  useEffect(() => {
    // update initial position of navigation
    // so we can know when to switch from sticky to normal
    setStickyNav((state) => ({
      ...state,
      offsetTop: navRef?.current?.offsetTop,
    }))
  }, [navRef])

  return {
    navVisible,
    toggleNav: () => setNavVisible(visible => !visible),
    navRef,
    isSticky
  }
}
